import { useSelector } from 'react-redux'

import { getIsAppName } from 'app-config'

import { selectHasAccountByEmail } from 'root-redux/selects/user'

import { PlatformOS } from 'root-constants'

import { getMobileOperatingSystem } from '../helpers/getMobileOperatingSystem'
import { useExperimentalFeatures } from './useExperimentalFeatures'

export const useUserAccountType = () => {
  const { isBlessedPathDomain, isAyahPathDomain } = getIsAppName()
  const { isAyah58RedirectToLwTest } = useExperimentalFeatures()
  const hasFirebaseAccount = useSelector(selectHasAccountByEmail)

  const isAndroid = getMobileOperatingSystem() === PlatformOS.ANDROID
  const isBlessedPathLearnWorldsUser = isBlessedPathDomain && isAndroid
  const isAyahPathLearnWorldsUser =
    isAyahPathDomain && isAyah58RedirectToLwTest && isAndroid

  return (
    !hasFirebaseAccount &&
    (isBlessedPathLearnWorldsUser || isAyahPathLearnWorldsUser)
  )
}
